import { Typography } from "@circle-react-uikit/Typography";
import { useCurrentUser } from "@circle-react/contexts/punditUserContext";
import { newSessionPath } from "@circle-react/helpers/urlHelpers";
import InnerHTML from "dangerously-set-html-content";

import { t } from "@/i18n-js/instance";
import { Button } from "@/react/components/SettingsApp/CompassCompat/Button";

interface CustomCommentsBanner {
  containerClassNames: string;
  lockedPostCtaContent: {
    body?: string;
    buttonLabel: string;
    buttonLink: string;
    heading: string;
  };
}

export const CustomCommentsBanner = ({
  lockedPostCtaContent,
  containerClassNames,
}: CustomCommentsBanner) => {
  const currentUser = useCurrentUser();

  return (
    <div className={containerClassNames}>
      <div>
        <Typography.TitleSm weight="semibold">
          {lockedPostCtaContent.heading}
        </Typography.TitleSm>
      </div>
      <div className="mt-4">
        {lockedPostCtaContent.body && (
          <Typography.BodyMd>
            <InnerHTML html={lockedPostCtaContent.body} />
          </Typography.BodyMd>
        )}
      </div>
      <div className="mt-6">
        <Button
          onClick={() => {
            window.location.href = lockedPostCtaContent.buttonLink;
          }}
        >
          {lockedPostCtaContent.buttonLabel}
        </Button>
      </div>
      {!currentUser && (
        <div className="mt-4">
          <Typography.LabelSm>{t("already_a_member")}</Typography.LabelSm>
          <a
            className="ml-1 text-sm font-medium text-link"
            href={newSessionPath({
              params: {
                post_login_redirect: window.location.href,
              },
            })}
          >
            {t("log_in")}
          </a>
        </div>
      )}
    </div>
  );
};
